import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LinkButton, LivePersonChat } from 'features/order-tracker/shared-components';
import {
  CHAT_BUTTON_PURPLE_WITH_ICON,
  CHAT_BUTTON_SECONDARY_WITH_ICON,
  SEND_MESSAGE_ANALYTICS,
} from 'features/order-tracker/shared-components/LivePersonChat/constants';
import { openOTPopUp } from 'features/order-tracker/store/actions';
import { useLivePersonPageChange } from 'features/order-tracker/store/hooks/useLivePersonPageChange';
import { getOrderStatusLivePersonProps, getOrderSummary } from 'features/order-tracker/store/selectors';
import { toggleMainWindowScroll } from 'features/order-tracker/utils';

import { BUTTON_LINK_TO_ENTRY_PAGE, BUTTON_TEXT, CVE_APP_LABEL, CVE_APP_URL, CVE_GUIDE_LABEL, CVE_GUIDE_URL, TRACK_ANOTHER_ORDER_ANALYTICS } from './constants';

import styles from './styles.module.scss';

export const ActionButtons: React.FC = () => {
  const livePersonDivId = useSelector(getOrderStatusLivePersonProps);
  const { isCloudVoiceOrder, isCVESwitchedOn } = useSelector(getOrderSummary);
  const dispatch = useDispatch();

  const openOTPopUpHandler = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();

    toggleMainWindowScroll();
    useLivePersonPageChange();
    setTimeout(() => dispatch(openOTPopUp()), 0);
  };

  if (isCloudVoiceOrder) {
    const cveLinkUrl = isCVESwitchedOn ? CVE_APP_URL : CVE_GUIDE_URL;
    const cveLinkLabel = isCVESwitchedOn ? CVE_APP_LABEL : CVE_GUIDE_LABEL;

    return (
      <div className={styles.buttonsGroup}>
        <LinkButton
          text={cveLinkLabel}
          link={cveLinkUrl}
          analytics={cveLinkLabel}
          className={styles.cveButton}
        />
        <LivePersonChat
          livePersonId={livePersonDivId}
          chatType={CHAT_BUTTON_SECONDARY_WITH_ICON}
          analytics={SEND_MESSAGE_ANALYTICS}
        />
      </div>
    );
  }

  return (
    <div className={styles.buttonsGroup}>
      <LivePersonChat
        livePersonId={livePersonDivId}
        chatType={CHAT_BUTTON_PURPLE_WITH_ICON}
        analytics={SEND_MESSAGE_ANALYTICS}
      />
      <LinkButton
        text={BUTTON_TEXT}
        link={BUTTON_LINK_TO_ENTRY_PAGE}
        analytics={TRACK_ANOTHER_ORDER_ANALYTICS}
        className={styles.button}
        action={openOTPopUpHandler}
      />
    </div>
  );
};
